import { QueryClient } from '@tanstack/react-query';
import { retryUnlessNotFound } from './query-errors';

const isDev = import.meta.env.MODE === 'development' || import.meta.env.DEV;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: isDev ? 1000 * 30 : 1000 * 60 * 5,
      gcTime: 1000 * 60 * 5,
      // Gõ sai id trên URL (404) → hiện trang 404 ngay, không retry; lỗi khác thử lại 1 lần
      retry: retryUnlessNotFound,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 0,
    },
  },
});
